import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardForDelivery extends BaseModelAPI {
	static entity = 'newobject1921';
	static entityName = 'controlcardfordelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.qtyCase = 0;
			this.qtyLock = 0;
			this.qtyOutstanding = 0;
			this.transactionType = '';
			this.transactionId = '';
			this.isUsed = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}